import type { FC } from 'react';
import React, { useContext } from 'react';

import { EMOJI_TYPE } from './../../ricos-content';
import {
  EditorContext,
  ModalServiceContext,
  PluginsEventsContext,
  RicosContext,
} from './../../ricos-context';
import { Panel, PanelHeader } from './../../ui-components';

import EmojiSelectorLazy from '../emoji-selector-lazy';
import { emojiModals } from '../types';

const EmojiInsertModal: FC = () => {
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const modalService = useContext(ModalServiceContext) || {};

  const closeModal = () => {
    modalService?.closeModal(emojiModals.insert);
  };

  const onEmojiAdd = (emoji: string) => {
    getPublicCommands()?.insertText(emoji);
    pluginsEvents.publishPluginAddSuccess({ pluginId: EMOJI_TYPE, params: { emoji } });
    closeModal();
  };

  return (
    <Panel onCloseButtonClick={closeModal} width={352}>
      <PanelHeader title={t('EmojiPlugin_InsertModal_Title')} />
      <EmojiSelectorLazy onEmojiAdd={onEmojiAdd} />
    </Panel>
  );
};

export default EmojiInsertModal;
